import {
  CAMPAIGN_PAGES_FETCH,
  CAMPAIGN_PAGE_FETCH,
  CAMPAIGN_PAGE_CREATE,
  CAMPAIGN_PAGE_UPDATE,
  CAMPAIGN_PAGE_DELETE,
  CAMPAIGN_PAGE_SUBMIT,
  CAMPAIGN_PAGE_DUPLICATE,
  CAMPAIGN_PAGE_LOADING,
  CAMPAIGN_PAGE_VIDEOS_FETCH,
  CAMPAIGN_PAGE_VIDEO_CREATE,
  CAMPAIGN_PAGE_VIDEO_DELETE
} from '@/store/actions/campaignPages.actions';

const initialState = {
  list: [],
  current: null,
  videos: [],
  loading: false,
  error: null
};

export default function campaignPages(state = initialState, action) {
  switch (action.type) {
    case CAMPAIGN_PAGE_LOADING:
      return { ...state, loading: true, error: null };

    case CAMPAIGN_PAGES_FETCH:
      return {
        ...state,
        list: action.payload.data || action.payload.campaign_pages || [],
        loading: false
      };

    case CAMPAIGN_PAGE_FETCH:
      return {
        ...state,
        current: action.payload.data || action.payload.campaign_page,
        loading: false
      };

    case CAMPAIGN_PAGE_CREATE: {
      const page = action.payload.data || action.payload.campaign_page;
      return {
        ...state,
        list: [page, ...state.list],
        current: page,
        loading: false
      };
    }

    case CAMPAIGN_PAGE_UPDATE:
    case CAMPAIGN_PAGE_SUBMIT: {
      const updated = action.payload.data || action.payload.campaign_page;
      return {
        ...state,
        list: state.list.map(p => (p.id === updated.id ? updated : p)),
        current: updated,
        loading: false
      };
    }

    case CAMPAIGN_PAGE_DELETE:
      return {
        ...state,
        list: state.list.filter(p => p.id !== action.payload.id),
        loading: false
      };

    case CAMPAIGN_PAGE_DUPLICATE: {
      const page = action.payload.data || action.payload.campaign_page;
      return {
        ...state,
        list: [page, ...state.list],
        loading: false
      };
    }

    case CAMPAIGN_PAGE_VIDEOS_FETCH:
      return { ...state, videos: action.payload.data || action.payload.campaign_page_videos || [] };

    case CAMPAIGN_PAGE_VIDEO_CREATE: {
      const video = action.payload.data || action.payload.campaign_page_video;
      return { ...state, videos: [video, ...state.videos] };
    }

    case CAMPAIGN_PAGE_VIDEO_DELETE:
      return { ...state, videos: state.videos.filter(v => v.id !== action.payload.id) };

    default:
      return state;
  }
}
